"use client";

import type { RefObject, SyntheticEvent } from "react";
import { CreatorVideoTimeline } from "./creator-video-timeline";

export type CreatorVideoPlayerProps = {
  videoSrc: string;
  videoRef: RefObject<HTMLVideoElement | null>;
  videoContainerRef: RefObject<HTMLDivElement | null>;
  videoWidth: number;
  progressPercent: number;
  onLoadedMetadata: (event: SyntheticEvent<HTMLVideoElement>) => void;
  onTimeUpdate: (event: SyntheticEvent<HTMLVideoElement>) => void;
  onLoadedData: (event: SyntheticEvent<HTMLVideoElement>) => void;
  onDurationChange?: (event: SyntheticEvent<HTMLVideoElement>) => void;
  onCanPlay?: (event: SyntheticEvent<HTMLVideoElement>) => void;
  onEnded: () => void;
  onPause: () => void;
  onPlay: () => void;
  onSeek?: (percent: number) => void;
};

/**
 * Renders the video player and its timeline overlay.
 */
export const CreatorVideoPlayer = ({
  videoSrc,
  videoRef,
  videoContainerRef,
  videoWidth,
  progressPercent,
  onLoadedMetadata,
  onTimeUpdate,
  onLoadedData,
  onDurationChange,
  onCanPlay,
  onEnded,
  onPause,
  onPlay,
  onSeek,
}: CreatorVideoPlayerProps) => (
  <div
    ref={videoContainerRef}
    className="relative flex h-full min-h-0 w-full flex-1 items-center justify-center overflow-visible select-none"
  >
    <video
      key={videoSrc}
      ref={videoRef}
      src={videoSrc}
      className="max-h-full rounded-t-3xl rounded-b-lg object-contain"
      playsInline
      onLoadedMetadata={onLoadedMetadata}
      onTimeUpdate={onTimeUpdate}
      onLoadedData={onLoadedData}
      onDurationChange={onDurationChange}
      onCanPlay={onCanPlay}
      onEnded={onEnded}
      onPause={onPause}
      onPlay={onPlay}
      preload="metadata"
    />

    <CreatorVideoTimeline
      videoWidth={videoWidth}
      progressPercent={progressPercent}
      onSeek={onSeek}
    />
  </div>
);
